import React from "react";
import { injectIntl } from "react-intl";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import "../Style.css";
import ReflexTestManagement from "./reflexTests/ReflexTestManagement";
import CalendarManagement from "./calendarManagement";
import ProgramManagement from "./program/ProgramManagement";
import LabNumberManagement from "./labNumber/LabNumberManagement";
import {
  GlobalMenuManagement,
  BillingMenuManagement,
  NonConformityMenuManagement,
  PatientMenuManagement,
  StudyMenuManagement,
  DictionaryManagement,
} from "./menu";
import CalculatedValue from "./calculatedValue/CalculatedValueForm";
import { CommonProperties } from "./menu/CommonProperties";
import ConfigMenuDisplay from "./generalConfig/common/ConfigMenuDisplay";
import SiteBrandingConfig from "./generalConfig/siteBranding/SiteBrandingConfig";
import ProviderMenu from "./ProviderMenu/ProviderMenu";
import ProviderTitleMenu from "./providerTitle/ProviderTitleMenu";
import DataExportStatus from "./DataExportStatus/DataExportStatus";
import LabelPresetList from "./labelPresets/LabelPresetList";
import { Redirect } from "react-router-dom";
import ResultReportingConfiguration from "./ResultReportingConfiguration/ResultReportingConfiguration";
import TestCatalog from "./testManagement/ViewTestCatalog";
import TestCatalogEditor from "./testCatalog/TestCatalogEditor";
import PanelEditor from "./testCatalog/PanelEditor";
import CombinedTestEditor from "./testCatalog/CombinedTestEditor";
import TestCatalogList from "./testCatalog/TestCatalogList";
import CatalogImport from "./catalogImport/CatalogImport";
import PushNotificationPage from "../notifications/PushNotificationPage.jsx";
import OrganizationManagement from "./OrganizationManagement/OrganizationManagement";
import OrganizationAddModify from "./OrganizationManagement/OrganizationAddModify";
import UserManagement from "./userManagement/UserManagement";
import UserAddModify from "./userManagement/UserAddModify";
import ManageMethod from "./testManagement/ManageMethod";
import BatchTestReassignmentAndCancelation from "./BatchTestReassignmentAndCancellation/BatchTestReassignmentAndCancelation";
import TestNotificationConfigMenu from "./testNotificationConfigMenu/TestNotificationConfigMenu";
import TestNotificationConfigEdit from "./testNotificationConfigMenu/TestNotificationConfigEdit";
import NotificationTriggerConfig from "./notificationTriggerConfig/NotificationTriggerConfig";
import SearchIndexManagement from "./searchIndexManagement/SearchIndexManagement";
import LoggingManagement from "./loggingManagement/LoggingManagement";
import TestManagementConfigMenu from "./testManagementConfigMenu/TestManagementConfigMenu";
import ResultSelectListAdd from "./testManagementConfigMenu/ResultSelectListAdd";
import TestAdd from "./testManagementConfigMenu/TestAdd";
import TestModifyEntry from "./testManagementConfigMenu/TestModifyEntry";
import TestOrderability from "./testManagementConfigMenu/TestOrderability";
import MethodCreate from "./testManagementConfigMenu/MethodCreate";
import TestSectionManagement from "./testManagementConfigMenu/TestSectionManagement";
import TestSectionCreate from "./testManagementConfigMenu/TestSectionCreate";
import TestSectionOrder from "./testManagementConfigMenu/TestSectionOrder";
import SampleTypeEditor from "./sampleTypeManagement/SampleTypeManagement.jsx";
import LegacySampleTypeManagement from "./testManagementConfigMenu/SampleTypeManagement";
import LabUnitManagement from "./labUnitManagement/LabUnitManagement.jsx";
import TestSectionTestAssign from "./testManagementConfigMenu/TestSectionTestAssign";
import SampleTypeOrder from "./testManagementConfigMenu/SampleTypeOrder";
import SampleTypeCreate from "./testManagementConfigMenu/SampleTypeCreate";
import SampleTypeTestAssign from "./testManagementConfigMenu/SampleTypeTestAssign";
import UomManagement from "./testManagementConfigMenu/UomManagement";
import UomCreate from "./testManagementConfigMenu/UomCreate";
import PanelManagement from "./testManagementConfigMenu/PanelManagement";
import PanelCreate from "./testManagementConfigMenu/PanelCreate";
import PanelOrder from "./testManagementConfigMenu/PanelOrder";
import PanelTestAssign from "./testManagementConfigMenu/PanelTestAssign";
import TestActivation from "./testManagementConfigMenu/TestActivation";
import TestRenameEntry from "./testManagementConfigMenu/TestRenameEntry";
import PanelRenameEntry from "./testManagementConfigMenu/PanelRenameEntry";
import SampleTypeRenameEntry from "./testManagementConfigMenu/SampleTypeRenameEntry";
import TestSectionRenameEntry from "./testManagementConfigMenu/TestSectionRenameEntry";
import TestSectionEdit from "./testManagementConfigMenu/TestSectionEdit";
import UomRenameEntry from "./testManagementConfigMenu/UomRenameEntry";
import SelectListRenameEntry from "./testManagementConfigMenu/SelectListRenameEntry";
import MethodRenameEntry from "./testManagementConfigMenu/MethodRenameEntry";
import ComplianceStandardsAdmin from "./complianceStandards/ComplianceStandardsAdmin";
import {
  LanguageManagement,
  TranslationManagement,
} from "./localizationManagement";
import ExternalConnectionMenu from "./externalConnections/ExternalConnectionMenu";
import ExternalConnectionAddModify from "./externalConnections/ExternalConnectionAddModify";
import DatabaseCleaning from "./databaseCleaning/DatabaseCleaning";
import VectorSurveillanceSetup from "./vectorSurveillance/VectorSurveillanceSetup";
import SampleAcceptanceChecklistSetup from "./sampleAcceptance/SampleAcceptanceChecklistSetup";
import AdminDashboard from "./AdminDashboard";
import StuckAnalyzerEvents from "./StuckAnalyzerEvents";
import MicrobiologyReferenceAdmin from "./microbiologyReference/MicrobiologyReferenceAdmin";

function Admin() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route
        path={`${path}/MicrobiologyReference/:section/:detailId?`}
        component={MicrobiologyReferenceAdmin}
      />
      <Route
        path={`${path}/calendarManagement`}
        component={CalendarManagement}
      />
      <Route path={`${path}/reflex`} component={ReflexTestManagement} />
      <Route path={`${path}/calculatedValue`} component={CalculatedValue} />
      <Route path={`${path}/TestCatalog`} component={TestCatalog} />
      <Route path={`${path}/TestCatalogList`} component={TestCatalogList} />
      <Route path={`${path}/CatalogImport`} component={CatalogImport} />
      <Route
        path={`${path}/stuckAnalyzerEvents`}
        render={() => <StuckAnalyzerEvents basePath={path} />}
      />
      <Route
        path={`${path}/TestCatalogEditor/group/:ids/:section?`}
        component={CombinedTestEditor}
      />
      {/* OGC-224 — panel entity segment must precede the generic :testId
          route, which would otherwise swallow "panel" as a test id. */}
      <Route
        path={`${path}/TestCatalogEditor/panel/:panelId/:section?`}
        component={PanelEditor}
      />
      <Route
        path={`${path}/TestCatalogEditor/:testId?/:section?`}
        component={TestCatalogEditor}
      />
      <Route path={`${path}/MethodManagement`} component={ManageMethod} />
      <Route path={`${path}/labNumber`} component={LabNumberManagement} />
      <Route path={`${path}/labelPresets`} component={LabelPresetList} />
      {/* OGC-781: the Programs rework keeps the live /program URL so bookmarks
          and deep links survive; /programV2 was its pre-release alias. */}
      <Redirect from={`${path}/programV2`} to={`${path}/program`} />
      <Route path={`${path}/program`} component={ProgramManagement} />
      <Route path={`${path}/providerMenu`} component={ProviderMenu} />
      <Route path={`${path}/providerTitleMenu`} component={ProviderTitleMenu} />
      <Route path={`${path}/dataExportStatus`} component={DataExportStatus} />
      <Route path={`${path}/NotifyUser`} component={PushNotificationPage} />
      <Redirect
        from={`${path}/barcodeConfiguration`}
        to={`${path}/labelPresets`}
      />
      <Route
        path={`${path}/organizationManagement`}
        component={OrganizationManagement}
      />
      <Route
        path={`${path}/organizationEdit`}
        component={OrganizationAddModify}
      />
      <Route
        path={`${path}/resultReportingConfiguration`}
        component={ResultReportingConfiguration}
      />
      <Route path={`${path}/userManagement`} component={UserManagement} />
      <Route
        path={`${path}/batchTestReassignment`}
        component={BatchTestReassignmentAndCancelation}
      />
      <Route path={`${path}/userEdit`} component={UserAddModify} />
      <Route
        path={`${path}/globalMenuManagement`}
        component={GlobalMenuManagement}
      />
      <Route
        path={`${path}/billingMenuManagement`}
        component={BillingMenuManagement}
      />
      <Route path={`${path}/SiteBrandingMenu`} component={SiteBrandingConfig} />
      <Route
        path={`${path}/nonConformityMenuManagement`}
        component={NonConformityMenuManagement}
      />
      <Route
        path={`${path}/patientMenuManagement`}
        component={PatientMenuManagement}
      />
      <Route
        path={`${path}/studyMenuManagement`}
        component={StudyMenuManagement}
      />
      <Route path={`${path}/commonproperties`} component={CommonProperties} />
      <Route
        path={`${path}/testManagementConfigMenu`}
        component={TestManagementConfigMenu}
      />
      <Route
        path={`${path}/ResultSelectListAdd`}
        component={ResultSelectListAdd}
      />
      {/* OGC-1112 FR-38: the unified New test flow (TestCatalogEditor/new) is the
          intended create path. The legacy 7-step Add Test and the legacy Modify Test
          are kept available in parallel temporarily during the transition. */}
      <Route path={`${path}/TestAdd`} component={TestAdd} />
      <Route path={`${path}/TestModifyEntry`} component={TestModifyEntry} />
      <Route path={`${path}/TestOrderability`} component={TestOrderability} />
      <Route path={`${path}/MethodCreate`} component={MethodCreate} />
      <Route
        path={`${path}/TestSectionManagement`}
        component={TestSectionManagement}
      />
      <Route path={`${path}/TestSectionCreate`} component={TestSectionCreate} />
      <Route path={`${path}/TestSectionOrder`} component={TestSectionOrder} />
      <Route
        path={`${path}/TestSectionTestAssign`}
        component={TestSectionTestAssign}
      />
      {/* Manage Sample Types under the legacy Test Management menu keeps opening
          the legacy page. The new editor answers on its own path so that link,
          and every other legacy one, is left where it was. */}
      <Route
        path={`${path}/SampleTypeManagement`}
        exact
        component={LegacySampleTypeManagement}
      />
      <Route
        path={`${path}/SampleTypeEditor/:sampleTypeId?/:section?`}
        component={SampleTypeEditor}
      />
      <Route
        path={`${path}/LabUnitManagement/:labUnitId?/:section?`}
        component={LabUnitManagement}
      />
      <Route path={`${path}/SampleTypeCreate`} component={SampleTypeCreate} />
      <Route path={`${path}/SampleTypeOrder`} component={SampleTypeOrder} />
      <Route
        path={`${path}/SampleTypeTestAssign`}
        component={SampleTypeTestAssign}
      />
      <Route path={`${path}/UomManagement`} component={UomManagement} />
      <Route path={`${path}/UomCreate`} component={UomCreate} />
      {/* OGC-224 — the legacy Panel pages stay authoritative until the new
          Panels context is stabilized; they are not redirected. */}
      <Route path={`${path}/PanelManagement`} component={PanelManagement} />
      <Route path={`${path}/PanelCreate`} component={PanelCreate} />
      <Route path={`${path}/PanelOrder`} component={PanelOrder} />
      <Route path={`${path}/PanelTestAssign`} component={PanelTestAssign} />
      <Route path={`${path}/TestActivation`} component={TestActivation} />
      <Route path={`${path}/TestRenameEntry`} component={TestRenameEntry} />
      <Route path={`${path}/PanelRenameEntry`} component={PanelRenameEntry} />
      <Route
        path={`${path}/SampleTypeRenameEntry`}
        component={SampleTypeRenameEntry}
      />
      <Route
        path={`${path}/TestSectionRenameEntry`}
        component={TestSectionRenameEntry}
      />
      <Route path={`${path}/TestSectionEdit`} component={TestSectionEdit} />
      <Route path={`${path}/UomRenameEntry`} component={UomRenameEntry} />
      <Route
        path={`${path}/SelectListRenameEntry`}
        component={SelectListRenameEntry}
      />
      <Route path={`${path}/MethodRenameEntry`} component={MethodRenameEntry} />
      <Route
        path={`${path}/ComplianceStandardsAdmin`}
        component={ComplianceStandardsAdmin}
      />
      <Route
        path={`${path}/languageManagement`}
        component={LanguageManagement}
      />
      <Route
        path={`${path}/translationManagement`}
        component={TranslationManagement}
      />
      <Route
        path={`${path}/NonConformityConfigurationMenu`}
        render={() => (
          <ConfigMenuDisplay
            menuType="NonConformityConfigurationMenu"
            label="Non Conformity Configuration Menu"
            id="sidenav.label.admin.formEntry.nonconformityconfig"
          />
        )}
      />
      <Route
        path={`${path}/MenuStatementConfigMenu`}
        render={() => (
          <ConfigMenuDisplay
            menuType="MenuStatementConfigMenu"
            label="Menu Statement Configuration Menu"
            id="sidenav.label.admin.formEntry.menustatementconfig"
          />
        )}
      />
      <Route
        path={`${path}/ValidationConfigurationMenu`}
        render={() => (
          <ConfigMenuDisplay
            menuType="ValidationConfigurationMenu"
            label="Validation Configuration Menu"
            id="sidenav.label.admin.formEntry.validationconfig"
          />
        )}
      />
      <Route
        path={`${path}/SampleEntryConfigurationMenu`}
        render={() => (
          <ConfigMenuDisplay
            menuType="SampleEntryConfigMenu"
            label="Sample Entry Configuration Menu"
            id="sidenav.label.admin.formEntry.sampleEntryconfig"
          />
        )}
      />
      <Route
        path={`${path}/WorkPlanConfigurationMenu`}
        render={() => (
          <ConfigMenuDisplay
            menuType="WorkplanConfigurationMenu"
            label="WorkPlan Configuration Menu"
            id="sidenav.label.admin.formEntry.Workplanconfig"
          />
        )}
      />
      <Route
        path={`${path}/SiteInformationMenu`}
        render={() => (
          <ConfigMenuDisplay
            menuType="SiteInformationMenu"
            label="Site Information Menu"
            id="sidenav.label.admin.formEntry.siteInfoconfig"
          />
        )}
      />
      <Route
        path={`${path}/ResultConfigurationMenu`}
        render={() => (
          <ConfigMenuDisplay
            menuType="ResultConfigurationMenu"
            label="Result Configuration Menu"
            id="sidenav.label.admin.formEntry.resultConfig"
          />
        )}
      />
      <Route
        path={`${path}/PatientConfigurationMenu`}
        render={() => (
          <ConfigMenuDisplay
            menuType="PatientConfigurationMenu"
            label="Patient Configuration Menu"
            id="sidenav.label.admin.formEntry.patientconfig"
          />
        )}
      />
      <Route
        path={`${path}/PrintedReportsConfigurationMenu`}
        render={() => (
          <ConfigMenuDisplay
            menuType="PrintedReportsConfigurationMenu"
            label="PrintedReports Configuration Menu"
            id="sidenav.label.admin.formEntry.PrintedReportsconfig"
          />
        )}
      />
      <Route
        path={`${path}/testNotificationConfigMenu`}
        component={TestNotificationConfigMenu}
      />
      <Route
        path={`${path}/testNotificationConfig`}
        component={TestNotificationConfigEdit}
      />
      <Route
        path={`${path}/notificationTriggerConfig`}
        component={NotificationTriggerConfig}
      />
      <Route path={`${path}/DictionaryMenu`} component={DictionaryManagement} />
      <Route
        path={`${path}/SearchIndexManagement`}
        component={SearchIndexManagement}
      />
      <Route path={`${path}/loggingManagement`} component={LoggingManagement} />
      <Route
        path={`${path}/externalConnections`}
        component={ExternalConnectionMenu}
      />
      <Route
        path={`${path}/externalConnectionEdit`}
        component={ExternalConnectionAddModify}
      />
      <Route path={`${path}/DatabaseCleaning`} component={DatabaseCleaning} />
      <Route
        path={`${path}/vectorSurveillanceSetup`}
        component={VectorSurveillanceSetup}
      />
      <Route
        path={`${path}/SampleAcceptanceChecklist`}
        component={SampleAcceptanceChecklistSetup}
      />
      <Route
        path={path}
        exact
        render={() => <AdminDashboard basePath={path} />}
      />
    </Switch>
  );
}

export default injectIntl(Admin);
